import React from "react";
import { useParams } from "react-router-dom";
import "./style.css";

import GridTableBapbm from "../../../components/GridTableBapbm";
import { Collapse } from "antd";

const { Panel } = Collapse;

const Bapbm = () => {
  let { nokapal, nokont, nobapb } = useParams();
  return (
    <div>
      <h3>
        NO. KAPAL {nokapal}, NO. KONT {nokont}, NO. BAPB {nobapb}
      </h3>
      <Collapse defaultActiveKey={["1"]}>
        <Panel header="DATA BAPB" key="1" className="content-height">
          <GridTableBapbm nokapal={nokapal} nokont={nokont} nobapb={nobapb} />
        </Panel>
      </Collapse>
    </div>
  );
};

export default Bapbm;
